import { computed, ref, watch } from 'vue'
import { useQuery } from '@vue/apollo-composable'

import { graphql } from '@/shared/graphql/router'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

const REPORT_PRODUCTS_QUERY = graphql(`
  query ReportProducts {
    reportProducts {
      id
      name
      description
      callout
      credits
      price {
        amount
        currencyCode
      }
    }
  }
`)

export interface ReportProduct {
  id: string
  name: string
  description: string
  callout?: string | null
  credits: number
  price: { amount: number; currencyCode: string }
}

export const useBuyReportCredits = (afterPurchase?: () => void) => {
  const { result, loading } = useQuery(REPORT_PRODUCTS_QUERY, null, {
    clientId: 'router',
  })

  const products = computed<ReportProduct[]>(
    () => result.value?.reportProducts ?? []
  )

  const selectedProductId = ref<string | null>(null)

  watch(
    products,
    (list) => {
      if (list.length && !selectedProductId.value) {
        selectedProductId.value = list.reduce((prev, curr) =>
          curr.credits > prev.credits ? curr : prev
        ).id
      }
    },
    { immediate: true }
  )

  const selectedProduct = computed(
    () => products.value.find((p) => p.id === selectedProductId.value) ?? null
  )

  const handleContinue = () => {
    if (!selectedProduct.value) return
    openDialog(Dialog.PayReportCredits, {
      stack: true,
      props: { product: selectedProduct.value, afterPurchase },
    })
  }

  return {
    loading,
    products,
    selectedProductId,
    selectedProduct,
    handleContinue,
  }
}
